export const ALL_COMPANIES_LABEL = 'Alle Unternehmen';
